import axiosInstance from '../api/axios.instance';

const cartAdminService = {
  getCartStatistics: async () => {
    const response = await axiosInstance.get('/carts/statistics');
    return response.data;
  }
};

export default cartAdminService;
